import { render, staticRenderFns } from "./XmUploadAbbreviation.vue?vue&type=template&id=f1e8d252&scoped=true"
import script from "./XmUploadAbbreviation.vue?vue&type=script&lang=js"
export * from "./XmUploadAbbreviation.vue?vue&type=script&lang=js"
import style0 from "./XmUploadAbbreviation.vue?vue&type=style&index=0&id=f1e8d252&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1e8d252",
  null
  
)

export default component.exports